<template>
	<NuxtLink
		:href="url"
		class="post-tile"
		:data-id="id"
	>
		<div class="post-image" />
		<div class="post-content">
			<div class="post-metadata mb-[8px]">
				<span v-if="category">
					{{ categoryParsed ? truncateText(categoryParsed, 15) : null }}
				</span>
				<span v-if="content">{{ calculateReadingTime(content) }} min read</span>
			</div>
			<h3 v-html="reponsiveTruncateText(title)" />
		</div>
	</NuxtLink>
</template>

<script setup>
import axios from "axios";
import categories from "~/utils/categories-data.json";

const $config = useRuntimeConfig();
const content = ref(null);
const category = ref(null);
const { id, title, url, media } = defineProps({
	id: {
		type: String,
		required: true
	},
	title: {
		type: String,
		required: true
	},
	url: {
		type: String,
		required: true
	},
	media: {
		type: Number
	}
});

const categoryParsed = computed(() => {
	if (!category.value) {
		return null;
	}
	const el = categories.find((item) => item.id === category.value);
	if (el) {
		return el.name;
	}

	return null;
});

const reponsiveTruncateText = (text) => {
	if (process.client) {
		if (window.innerWidth > 1280) {
			return truncateText(text, 49);
		}

		return truncateText(text, 62);
	} else {
		return truncateText(text, 49);
	}
};

onMounted(async () => {
	try {
		if (process.client && media && media !== 0) {
			const { data, status } = await axios.get(
				`${$config.public.hostname}wp-json/wp/v2/media/${media}?_embed`
			);

			const postImage = document.querySelector(`[data-id="${id}"] .post-image`);

			if (data && status === 200) {
				postImage.style.backgroundImage = `url("${
					data.source_url
						? imageLinkFormatter(
								data.source_url,
								370,
								70,
								"PRODUCTION",
								"https://content.timothysykes.com"
								// eslint-disable-next-line no-mixed-spaces-and-tabs
						  )
						: $config.public.current_hostname + "images/default_blog_image.webp"
				}")`;
			}
		}
	} catch (e) {
		const postImage = document.querySelector(`[data-id="${id}"] .post-image`);

		postImage.style.backgroundImage = `url("${
			$config.public.current_hostname + "images/default_blog_image.webp"
		}")`;
		// eslint-disable-next-line no-console
		console.log(
			"ERROR FETCHING SEARCHED POST DATA",
			$config.public.env === "production" ? e.message : e
		);
	}
});
</script>

<style lang="scss" scoped>
@import "@assets/utils.scss";

.post-tile {
	border-radius: 8px;
	overflow: hidden;
	filter: drop-shadow(0px 7px 20px rgba(0, 0, 0, 0.1));
}

.post-image {
	height: 200px;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	background-color: $primary-300;
	overflow: hidden;
	background-size: cover;
	background-position: center;
}

.post-metadata {
	display: flex;

	span {
		line-height: 1;
		font-family: Rubik;
		font-size: 18x;
		font-style: normal;
		font-weight: 400;
		color: $neutral-400;
	}

	span:first-child {
		padding-right: 8px;
		border-right: 1px solid $neutral-400;
	}

	span:last-child {
		padding-left: 8px;
	}
}

.post-content {
	padding: 8px 16px 16px;
	background-color: white;

	@include breakpoint(md) {
		min-height: 92px;
	}
}

.post-content h3 {
	color: $neutral-800;
	/* Heading/H6 */
	font-family: Fira Sans;
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: 120%;
	/* 21.6px */
}
</style>
